import { FilterGroup } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '..';
import { notEmpty } from '@/utilities/helpers';
import { getApplicationCountryFilter } from './applicationCountry';
import { getCountryOfResidenceFilter } from './countryOfResidence';
import { getFeeStatusFilter } from './feeStatus';
import { getNationalityFilter } from './nationality';

export const getStudentsFilterGroup = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'STUDENTS',
    filters: [
      getApplicationCountryFilter(props),
      getCountryOfResidenceFilter(props),
      getNationalityFilter(props),
      getFeeStatusFilter(props),
    ].filter(notEmpty),
  };
};
